var _rect, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHydraulicEnergy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 511.981 511.981",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 330.68,
    y: 32.031,
    width: 21.343,
    height: 42.654
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.806,170.619c0.406,0.047,0.828,0.078,1.234,0.078h341.283c5.891,0,10.656-4.765,10.656-10.656  v-64.06c0-2.828-1.125-5.531-3.125-7.531s-4.703-3.125-7.531-3.125H170.712v-0.094h-10.671c-42.749,0-82.935,16.64-113.167,46.873  C16.655,162.323,0,202.524,0,245.272c0,42.733,16.655,82.934,46.874,113.152c27.702,27.702,63.763,43.982,102.496,46.514v0.359  h10.672h10.671h181.243c41.155,0,74.654,33.498,74.654,74.653c0,5.891,4.764,10.672,10.654,10.672h64.061  c5.891,0,10.656-4.781,10.656-10.672c0-42.749-16.641-82.935-46.873-113.152c-27.703-27.702-63.763-43.982-102.497-46.529v-0.344  H170.712h-10.671c-41.171,0-74.654-33.498-74.654-74.653C85.387,204.508,118.214,171.291,158.806,170.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M351.955,415.97c-5.891,0-10.671-4.781-10.671-10.672v-85.372c0-5.891,4.78-10.671,10.671-10.671   c5.875,0,10.655,4.78,10.655,10.671v85.372C362.61,411.188,357.83,415.97,351.955,415.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M160.041,415.97c-5.891,0-10.672-4.781-10.672-10.672v-85.372c0-5.891,4.781-10.671,10.672-10.671   c5.89,0,10.671,4.78,10.671,10.671v85.372C170.712,411.188,165.931,415.97,160.041,415.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M160.041,181.368c-5.891,0-10.672-4.781-10.672-10.671V85.325c0-5.891,4.781-10.672,10.672-10.672   c5.89,0,10.671,4.781,10.671,10.672v85.372C170.712,176.587,165.931,181.368,160.041,181.368z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#656D78"
    },
    d: "M423.547,67.138c-2-2-4.719-3.109-7.547-3.109H266.693  c-5.891,0-10.672,4.765-10.672,10.656v106.652c0,2.828,1.125,5.547,3.125,7.547s4.719,3.125,7.547,3.125H416  c5.891,0,10.672-4.781,10.672-10.671V74.685C426.672,71.857,425.547,69.138,423.547,67.138z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M423.547,67.138c-2-2-4.719-3.109-7.547-3.109H266.693   c-5.891,0-10.672,4.765-10.672,10.656v106.652c0,2.828,1.125,5.547,3.125,7.547s4.719,3.125,7.547,3.125H416   c5.891,0,10.672-4.781,10.672-10.671V74.685C426.672,71.857,425.547,69.138,423.547,67.138z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M426.672,170.666c0,5.89-4.781,10.671-10.672,10.671H266.693  c-2.828,0-5.547-1.125-7.547-3.125s-3.125-4.719-3.125-7.546v10.671c0,2.828,1.125,5.547,3.125,7.547s4.719,3.125,7.547,3.125H416  c5.891,0,10.672-4.781,10.672-10.671V74.685l0,0V170.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M384.001,42.686h-85.31c-5.89,0-10.671-4.766-10.671-10.656s4.781-10.671,10.671-10.671h85.31  c5.891,0,10.672,4.781,10.672,10.671S389.891,42.686,384.001,42.686z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydraulicEnergy);
export default __webpack_public_path__ + "static/media/hydraulic-energy.d5e4a4e9b0aed82cb39549e5f40b47c6.svg";
export { ForwardRef as ReactComponent };